export const FILTER_KEYS = {
  POLICIES_OVERTIME: 'policies-overtime',
  POLICIES_LEAVE: 'policies-leave',
  POLICIES_SHIFT: 'policies-shift',
  POLICIES_RECRUITMENT: 'policies-recruitment',
  POLICIES_EXPENSE: 'policies-expense',
  ORG_OFFICES: 'org-offices',
  ORG_DEPARTMENTS: 'org-departments',
  ORG_DESIGNATIONS: 'org-designations',
  ORG_CUSTOM_FIELDS: 'org-custom-fields',
  ORG_GRADES: 'org-grades',
  ROLES_MANAGEMENT: 'roles-management',
  ORG_COMPANY: 'org-company',
  PAYROLL_SALARY_SHEET: 'payroll-salary-sheet',
  PAYROLL_LEAVE: 'payroll-leave',
  PAYROLL_BONUS: 'payroll-bonus',
  JOB_POST: 'job-post',
  JOB_APPLICANT: 'job-applicant',
  JOB_SHORTLISTED: 'job-shortlisted',
  ASSESS_LIST: 'assess-list',
  ASSESS_SCORES: 'assess-scores',
  INTERVIEW_SCHEDULED: 'interview_scheduled',
  INTERVIEW_SCORES: 'interview_scores',
  RM_RECENT_JOB_POST: 'rm-recent-job-post',
  HIR_OFFER_LETTER: 'hir-offer-letter',
  INTERVIEW_MARKS: 'interview-marks',
  SEND_OFFER_LETTER: 'send-offer-letter',
  HIRING_PIPELINE: 'hiring_pipeline',
  EV_ASSESSMENT: 'ev-assessment',
  EV_INTERVIEW: 'ev-interview',
  PERFORMANCE_SUMMARY: 'performance-summary',
  PERFORMANCE_OPEN_KPI: 'performance-open-kpi',
  PERFORMANCE_KPI_REPORT: 'performance-kpi-report',
  PERFORMANCE_APPRAISAL_REPORT: 'performance-appraisal-report',
  TALENT_HUNT: 'talent-hunt',
  EMP_OWN_KPI: 'emp-own-kpi',
  EMP_OWN_APPRAISAL: 'emp-own-appraisal',
  LM_TEAM_KPI: 'lm-team-kpi',
  LM_TEAM_APPRAISAL: 'lm-team-appraisal',
} as const;

export const DISCLOSER_KEYS = {
  POLICIES_OVERTIME: 'policies-overtime',
  POLICIES_LEAVE: 'policies-leave',
  POLICIES_SHIFT: 'policies-shift',
  POLICIES_RECRUITMENT: 'policies-recruitment',
  POLICIES_EXPENSE: 'policies-expense',
  ORG_OFFICES: 'org-offices',
  ORG_DEPARTMENTS: 'org-departments',
  ORG_DESIGNATIONS: 'org-designations',
  ORG_CUSTOM_FIELDS: 'org-custom-fields',
  ORG_GRADES: 'org-grades',
  ROLES_MANAGEMENT: 'roles-management',
  ORG_COMPANY: 'org-company',
  PAYROLL_SALARY_SHEET: 'payroll-salary-sheet',
  PAYROLL_LEAVE: 'payroll-leave',
  PAYROLL_BONUS: 'payroll-bonus',

  // Recruitment
  MANAGE_JOB_POST: 'manage-job-post',
  JOB_POST: 'job-post',
  JOB_POST_CREATE: 'job-post-create',
  JOB_APPLICANT: 'job-applicant',
  JOB_SHORTLISTED: 'job-shortlisted',
  ASSESS_LIST: 'assess-list',
  ASSESS_SCORES: 'assess-scores',
  SCHEDULED_INTERVIEW: 'interview_scheduled',
  INTERVIEW_SCORES: 'interview_scores',
  RM_RECENT_JOB_POST: 'rm-recent-job-post',
  HIR_OFFER_LETTER: 'hir-offer-letter',
  INTERVIEW_MARKS: 'interview-marks',
  SEND_OFFER_LETTER: 'send-offer-letter',
  EV_ASSESSMENT: 'ev-assessment',
  EV_INTERVIEW: 'ev-interview',
  PERFORMANCE_SUMMARY: 'performance-summary',
  PERFORMANCE_OPEN_KPI: 'performance-open-kpi',
  PERFORMANCE_KPI_REPORT: 'performance-kpi-report',
  PERFORMANCE_APPRISAL_REPORT: 'performance-apprisal-report',
  PERFORMANCE_OPEN_APPRAISAL: 'performance-open-appraisal',
  EMP_OWN_KPI: 'emp-own-kpi',
  EMP_OWN_APPRAISAL: 'emp-own-appraisal',
} as const;
